import React, { Component } from 'react';
import { ClipLoader } from 'react-spinners';
import { Card, } from '@material-ui/core'

export default class Loader extends Component {
    constructor(props) {
        super(props);

        this.state = {}
    }

    render() {
        return (
            <div style={{
                width: '100%',
                height: '100%',
                backgroundColor: 'rgb(239,239,239,0.7)',
                position: 'absolute',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 999999,
                display: this.props.isLoading === false ? 'none' : 'flex',
                top: 0,
                left: 0,
            }}>
                <Card style={{
                    boxShadow: '1px 1px 0.6vw 1px #000',
                    width: '12vw',
                    height: '6vw',
                    background: '#1A5276',
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                }}>
                    <ClipLoader color='white' loading={this.props.loading} size={50} />
                    <span style={{ textAlign: 'center', fontWeight: '500', color: 'white', fontSize: '0.85vw' }} >
                        Yükleniyor...
                    </span>
                </Card>
            </div>
        )
    }
}

